import httpClient from '../httpClient';

const sendContactUsEmail = email => {
  return httpClient.post(`/contact-us`, email);
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { sendContactUsEmail };
